import {AntiSegmentRule, IAntiSegmentDto} from "@/modules/Segmentation/models/AntiSegmentRule";
import {ISegmentDto, SegmentRule} from "@/modules/Segmentation/models/SegmentRule";
import {ISegmentationInfoDto, SegmentationInfo} from "@/modules/Segmentation/models/SegmentationInfo";

export class LogContext {
    segmentationId: string;
    rule: SegmentRule | AntiSegmentRule | null;
    info: SegmentationInfo;

    constructor(
        dtoOrId: ILogContextDto | string = "",
        rule: SegmentRule | AntiSegmentRule = new AntiSegmentRule(),
        info: SegmentationInfo = new SegmentationInfo(),
    ) {
        if (typeof dtoOrId !== "string") {
            this.segmentationId = dtoOrId.segmentationId ?? "";

            if (dtoOrId.rule) {
                this.rule = SegmentRule.isISegmentDto(dtoOrId.rule)
                    ? new SegmentRule(dtoOrId.rule)
                    : new AntiSegmentRule(dtoOrId.rule);
            } else {
                this.rule = null;
            }

            this.info = new SegmentationInfo(dtoOrId.target);
        } else {
            this.segmentationId = dtoOrId;
            this.rule = rule;
            this.info = info;
        }
    }
}

export type ILogContextDto = Readonly<{
    "segmentationId"?: string;
    "target": ISegmentationInfoDto;
    "rule"?: IAntiSegmentDto | ISegmentDto;
}>;
